import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../../shared/services/dataService';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import {  Subscription } from 'rxjs/Rx';
import { UserService } from 'app/shared/services/userService';
import { CaseData } from '../../shared/models/caseValidation';
import { UserAccess } from 'app/shared/models/userModel';
import { InterviewDetails } from 'app/shared/services/interviewDetailsService'
import { MatTabGroup } from '@Angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';
import { CaseService } from '../../shared/services/caseService';
import { Case } from 'app/shared/models/caseModel';


@Component({
    selector: 'Case-Template',
    templateUrl: '../case-template/caseTemplate.component.html',
    styleUrls: ['../case-template/caseTemplate.component.css']
})
export class CaseTemplateComponent implements OnInit, OnDestroy {
    private caseId: string;
    private modalData: any;
    isModalDataLoaded: any;
    modalGroups: any;
    private timeoutTag: any;
    private comparsionRule: any;
    private ocmeNum: any;
    private jurisdiction: any;
    private hasComments: any;
    private interviewDetails: InterviewDetails;
    private caseStatus: string;
    private previousStep = 0;
    private caseDetails: Case;

    private options = {
        id: 2,
        timeOut: 4 * 1000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: false,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };
    showErrors = false;
    groups: Array<string> = [];
    users: any[];
    currentUser: any;
    tabs: Array<any> = [];
    selectedTab: string = "Demographics";
    @ViewChild('stepper', { static: false }) set setStepper(stepper: MatStepper) {
        if (stepper && this.route.snapshot.params['analysis'] != undefined) {
            stepper.selectedIndex = 2;
        }
    }
    private subscription: Subscription;
    private navState: any;

    constructor(private dataService: DataService, private caseService: CaseService,
        private userService: UserService, private router: Router, private route: ActivatedRoute,
        private snackBar: MatSnackBar, private formBuilder: FormBuilder) {
        this.navState = this.router.getCurrentNavigation()?.extras.state;
        this.subscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
                if (event.url.includes('recommendation-tracker')) {
                    this.router.navigate(['/recommendation-tracker'], {
                        state: this.navState
                    })
                }
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ngOnInit() {
        this.userService.GetCurrentUser().then(u => {
            this.currentUser = u.User;
        });

        this.getCaseInformation();

        this.dataService.getAccess().subscribe((access) => {
            if (access.Groups) {
                this.groups = access.Groups.split(',');
            }
        });
    }

    public printDetails() {
        EventAggregator.publish(EventList.popupTriggered, {
            type: 'caseDetails',
            value: {
                caseDetails: this.caseDetails,
                printMode: true
            }
        });
    }

    selectTab(event, stepper: MatStepper) {
        var prev = this.selectedTab;
        this.selectedTab = event.tab.textLabel;
        if (prev != this.selectedTab) {
            stepper.selectedIndex = 0;
            this.previousStep = stepper.selectedIndex;
        }
    }

    selectStep(event, stepper: MatStepper) {
        this.previousStep = stepper.selectedIndex;
    }
    stepperLabel(groupName: string) {
        groupName = groupName.replace("Records", "");
        return groupName;
    }
    next(stepper: MatStepper, tab: MatTabGroup, event) {
        if (stepper.selectedIndex === stepper.steps.length - 1 && this.previousStep == stepper.selectedIndex && tab.selectedIndex !== tab._tabs.length - 1) {
            tab.selectedIndex = tab.selectedIndex + 1;
            stepper.selectedIndex = 0;
        }
        this.previousStep = stepper.selectedIndex;

    }
    back(stepper: MatStepper, tab: MatTabGroup) {
        if (stepper.selectedIndex === 0 && this.previousStep == stepper.selectedIndex && tab.selectedIndex !== 0) {
            tab.selectedIndex = tab.selectedIndex - 1;
            stepper.selectedIndex = 0;
        }
        this.previousStep = stepper.selectedIndex;

    }
    private getCaseInformation(): void {
        this.caseId = this.route.snapshot.params['id'];
        this.caseService.getCaseInformation(this.caseId).then(x => { this.response(x); });
    }

    private removeFieldsFromCaseData(fields: any) {
        fields.forEach(field => {
            if (field.InnerGroup) {
                CaseData.clearCaseData(field.Title);
                this.removeFieldsFromCaseData(field.InnerGroup);
            }
            CaseData.clearCaseData(field.Name);
        });
    }

    private addFieldsToCaseData(fields: any): void {
        fields.forEach(field => {
            if (true || field.Required) {
                let value = this.getFieldValue(field.Name);
                if (!field.InnerGroup || field.InnerGroupRequiredIfChecked) {
                    if (field.Type == 'Checkbox' && value) {
                        value = (value.toString().toLowerCase() == 'true');
                    }
                    if (field.Type == 'MultiSelection' && value && !Array.isArray(value)) {
                        value = value.split(',');
                    }
                    if (!value) value = "";
                    if (Array.isArray(value) && value.length == 0) {
                        value = "";
                    }
                    if (!(CaseData.getCaseData().find(x => x.key == field.key))) {
                        CaseData.setCaseData({
                            key: field.Name, IsRequired: field.Required,
                            value: value, Type: field.Type
                        });
                    }
                }
                if ((field.InnerGroup && !field.InnerGroupRequiredIfChecked) || (field.InnerGroupRequiredIfChecked && (value && value != 'No' && value != 'Unknown'))) {
                    this.addFieldsToCaseData(field.InnerGroup);
                }
                if (field.InnerGroupRequiredIfChecked && (value == undefined || value == 'No' || value == 'Unknown' || (Array.isArray(value) && value.length == 0))) {
                    CaseData.clearCaseData(field.Title);
                    this.removeFieldsFromCaseData(field.InnerGroup);
                }
            }
        });
    }

    private response(resp: Case): void {
        this.caseDetails = resp;
        this.ocmeNum = resp.OCME;
        this.jurisdiction = resp.Jurisdiction;
        this.modalData = resp.Data;
        this.caseStatus = resp.Status;
        this.hasComments = resp.HasComments;

        this.interviewDetails = this.getInterviewDetailsFromData(resp.Data);

        this.isModalDataLoaded = true;
        if (this.groups.length === 1 && this.groups[0] && !resp.Data.CountyOfReview) {
            resp.Data.CountyOfReview = this.groups[0];
            this.caseService.saveCase(this.caseId, { 'CountyOfReview': this.groups[0] });
        }
        this.dataService.getTemplate(resp.Template).then(template => {
            this.modalGroups = template['Groups'];
            this.modalGroups.forEach((group) => {
                const formGroup: FormGroup = this.formBuilder.group({
                    groupCtl: [group.Name, Validators.required]
                });
                formGroup.valueChanges.subscribe((change) => {
                    this.setRequiredTabs()
                });

                group.formGroup = formGroup;

                // Our data validation works on CaseData, so it's essential to have all the form
                // fields added to it with their 'required' attribute correctly populated to ensure
                // that we do not allow premature submission of the form. There can be cases where
                // these form fields are not added to CaseData as they are added to CaseData when
                // they are rendered. This rendering is behind an ngIf, which means that they don't
                // get added to CaseData until the tab they reside in is clicked. This could lead to
                // the validation on a required field not being met, and an incomplete form submission.
                this.addFieldsToCaseData(group.Fields);
            });

            this.comparsionRule = template['Comparison'];
            const caseInfoGroup = this.modalGroups.find(g => g.Name === "Case Information");
            const jurisdictions = [this.modalData.CountyofDeath, this.modalData.ResidentJurisdiction];
            this.userService.getJurisdictionUsers(jurisdictions).then(u => {
                this.users = u.map((user: UserAccess) => ({ name: user.FirstName + ' ' + user.LastName, value: user.Id }));

                const caseInfoFields = caseInfoGroup.Fields.find(f => f.Name === "CaseOwner");
                caseInfoFields.Options = this.users;
            });
        });

        CaseData.OnChange = this.onChange.bind(this);
    }


    private getInterviewDetailsFromData(data: any): any {
        const familyInterviewsConducted: any = data["FamilyInterviews"];
        const numInterviewsConducted: any = data["NumberFamilyInterviewsConducted"];
        const familyInterviewDescription: any = data["FamilyInterviewsDetails"];
        let familyInterviewDocuments: any = [];

        if (data["FamilyInterviewDocuments"]) {
            familyInterviewDocuments = JSON.parse(data["FamilyInterviewDocuments"]);
        }

        const interviewDetails = new InterviewDetails();
        interviewDetails.FamilyInterviewsConducted = familyInterviewsConducted || 'No';
        interviewDetails.NumberInterviewsConducted = numInterviewsConducted || 0;
        interviewDetails.InterviewDescription = familyInterviewDescription || '';
        interviewDetails.InterviewDocuments = familyInterviewDocuments || [];

        return interviewDetails;
    }

    private getFieldValue(fieldName: string): any {
        if (this.modalData[fieldName] != null) {
            return this.modalData[fieldName]
        }
        return null;
    }

    private getActiveIds(): string {
        let activeids = '';
        for (let index = 0; index < this.modalGroups.length; index++) {
            activeids += 'ngb-panel-' + index + ',';
        }
        return activeids.replace(/,\s*$/, '');
    }

    private onChange(): void //SK_clears the timeout and saves the chanes
    {
        if (this.timeoutTag) {
            clearTimeout(this.timeoutTag);
        }


        if (CaseData.changeset["CountyofDeath"] !== undefined || CaseData.changeset["ResidentJurisdiction"] !== undefined) {
            const caseOwnerField = this.modalGroups.find(g => g.Name === "Case Information").Fields.find(f => f.Name === "CaseOwner");

            const incidentJurisdiction = CaseData.changeset["CountyofDeath"] !== undefined ?
                CaseData.changeset["CountyofDeath"] :
                CaseData.getCaseData().find((f) => { return f.key === "CountyofDeath" }).value;

            const residentJurisdiction = CaseData.changeset["ResidentJurisdiction"] !== undefined ?
                CaseData.changeset["ResidentJurisdiction"] :
                CaseData.getCaseData().find((f) => { return f.key === "ResidentJurisdiction" }).value;

            const jurisdictions = [incidentJurisdiction, residentJurisdiction];
            this.userService.getJurisdictionUsers(jurisdictions).then(u => {
                this.users = u.map((user: UserAccess) => ({ name: user.FirstName + ' ' + user.LastName, value: user.Id, isDefault: this.currentUser.Id === user.Id }));

                caseOwnerField.Options = this.users;
            });
        }

        this.setRequiredTabs();
        this.timeoutTag = setTimeout(this.saveChanges.bind(this), 3 * 1000);
    }

    private saveChanges(): void {
        this.timeoutTag = null;
        const oldChanges = CaseData.changeset;
        CaseData.changeset = {};

        this.caseService.saveCase(this.caseId, oldChanges)
            .then(r => this.snackBar.open('Changes Successfully Saved', 'close', { duration: 3000 }))
            .catch(r => this.snackBar.open('Error attempting to Save', 'close', { duration: 5000 }))//SK Check the code below and make sure the two catch bloacks are working fine.
            .catch(r => {
                for (var k in oldChanges) {
                    // pushing any changes back into the changeset
                    // ignore anything that's already been re-added (from new input)
                    if (CaseData.changeset[k]) continue;
                    CaseData.changeset[k] = oldChanges[k];
                }
            });


    }


    private is_valid(group) {
        if (group.Name != null) {
            // This is actually a field
            var val = this.getFieldValue(group.Name);
            if (group.Required) {
                if (val == null || val === "" || (Array.isArray(val) && val.length == 0)) {
                    return false;
                }
            }
            if (group.InnerGroupRequiredIfChecked && val != "Yes") return true;
        }

        if(!group.InnerGroup) return true;
        var ret = true;
        for (var i = 0; i < group.InnerGroup.length; i++) {
            var innergroup = group.InnerGroup[i];
            ret = ret && this.is_valid(innergroup);
        }

        if (ret && group.AllRequired && !this.is_checkbox_group(group)) {
            var true_count = 0;
            var false_count = 0;
            for (var i = 0; i < group.InnerGroup.length; i++) {
                var innergroup = group.InnerGroup[i];
                if (this.is_allrequired_valid(innergroup)) {
                    true_count++;
                } else {
                    false_count++;
                }
            }
            if (true_count == 0 || false_count == 0) {
                return true;
            }
            else {
                return false;
            }
        }

        return ret;
    }

    private is_checkbox_group(group) {
        if (group.Name != null) return false;
        for (var i = 0; i < group.InnerGroup.length; i++) {
            var innergroup = group.InnerGroup[i];
            if (innergroup.Type !== "Checkbox") return false;
        }
        return true;
    }

    private is_allrequired_valid(group) {
        if (group.Name != null) {
            var val = this.getFieldValue(group.Name);
            if (val == null || val === "" || (Array.isArray(val) && val.length == 0)) {
                return false;
            }
            return true;
        }

        // Now we check if a group is filled or not
        // We only check for checkbox groups
        if (this.is_checkbox_group(group)) {
            var ret = false;
            for (var i = 0; i < group.InnerGroup.length; i++) {
                var innergroup = group.InnerGroup[i];
                var val = this.getFieldValue(innergroup.Name);
                if (val == null || val == false || val === "false") ret = ret || false;
                else ret = ret || true;
            }

            return ret;
        }
        return true;
    }

    public isGroupValid(group) {
        for (var i = 0; i < group.Fields.length; i++) {
            var field = group.Fields[i];
            if (!this.is_valid(field)) return false;
        }
        return true;
    }

    private setRequiredTabs() {
        if (this.modalGroups) {
            this.tabs = [];
            this.modalGroups.forEach((group) => {
                if (this.tabs.filter((tab) => tab.name === group.Tab).length === 0) {
                    this.tabs.push({ name: group.Tab, valid: true });
                }

                var tab = this.tabs.find((tab) => tab.name === group.Tab);
                tab.valid = tab.valid ? this.isGroupValid(group) : false;
            });
        }
    }

    private dateValidation(orignalValue: any, comparisonType: string, targetValue: any, type: string): boolean {
        let orignalDate;
        let targetDate;

        if (type == 'Date') {
            orignalDate = new Date(orignalValue).getTime();
            targetDate = new Date(targetValue).getTime();
        } else {
            orignalDate = orignalValue;
            targetDate = targetValue;
        }

        if (comparisonType == 'GT' && (orignalDate > targetDate)) {
            return true;
        } else if (comparisonType == 'GTE' && (orignalDate >= targetDate)) {
            return true;
        } else if (comparisonType == 'EQ' && (orignalDate == targetDate)) {
            return true;
        } else if (comparisonType == 'NEQ' && (orignalDate != targetDate)) {
            return true;
        } else if (comparisonType == 'LTE' && (orignalDate <= targetDate)) {
            return true;
        } else if (comparisonType == 'LT' && (orignalDate < targetDate)) {
            return true;
        }

        return false;
    }

    private isValidComparsionRule(): Array<string> {
        const errors = Array<string>();

        if (this.comparsionRule) {
            this.comparsionRule.forEach(rule => {
                const orignalValue = CaseData.getCaseData().filter(x => x.key == rule.Orignal).length > 0 ?
                    CaseData.getCaseData().find(x => x.key == rule.Orignal).value : '';
                const targetValue = CaseData.getCaseData().filter(x => x.key == rule.Target).length > 0 ?
                    CaseData.getCaseData().find(x => x.key == rule.Target).value : '';

                if (!this.dateValidation(orignalValue, rule.Operator, targetValue, rule.Type)) {
                    errors.push(rule.Error);
                }
            });
        }

        return errors;
    }

    private hasErrors(): boolean {
        this.modalGroups.forEach((group) => {
            this.addFieldsToCaseData(group.Fields);
        });

        for(var i = 0; i < this.modalGroups.length; i++) {
            if (!this.isGroupValid(this.modalGroups[i])) return true;
        }

        if (this.isValidComparsionRule.length > 0) {
            return true;
        }

        if (this.isInterviewDetailsNotValid()) return true;

        return CaseData.isValid();
    }

    private isInterviewDetailsNotValid(): boolean {
        if (this.interviewDetails.FamilyInterviewsConducted === 'Yes') {
            let num: Number = this.interviewDetails.NumberInterviewsConducted;

            return num <= 0;
        }

        return false;
    }

    onChatClicked() {
        EventAggregator.publish(EventList.popupTriggered, {
            type: 'caseCommentThread',
            value: { caseId: this.caseId, ocme: this.ocmeNum }
        });
    }

    private submit(): void {
        if (!this.hasErrors()) {
            this.caseService.submitCase(this.caseId, null);
            this.router.navigate(['dashboard']);
        }
        else {
            this.showErrors = true;
            this.snackBar.open('Please complete all required fields. Required fields are identified by red lines.', 'close', { duration: 3000 })
        }


    }
}
